import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import { jsx as _jsx } from "react/jsx-runtime";
export function PreloadImageLink({
  href
}) {
  return /*#__PURE__*/_jsx(DocumentHead, {
    children: /*#__PURE__*/_jsx("link", {
      rel: "preload",
      href: href,
      as: "image"
    })
  });
}